import { useTranslation } from 'next-i18next';
import { cn } from '@/utils/tailwind.util';
import { usePaginationContext } from './context/PaginationContext';
export const PageIndicator = ({
  className
}: {
  className?: string;
}) => {
  const {
    currentPage,
    totalPage
  } = usePaginationContext();
  const {
    t
  } = useTranslation(['common']);
  return <div className={cn('absolute bottom-[28px] left-[30px] z-40 rounded-sm bg-opacity-white-10 px-sm py-xs shadow-lg shadow-key-strong backdrop-blur-[2px]', className)} data-sentry-component="PageIndicator" data-sentry-source-file="PageIndicator.tsx">
      <span className="text-body-sm-semibold text-alternative">
        {t('common:quizWorksheet.pdfView.page', {
        currentPage,
        totalPage
      })}
      </span>
    </div>;
};